
export class Category {
  constructor(
    public id: number,
    public name: string,
    public iconUrl?: string,
    public parentCategoryId?: number,
    public showOnMainPage?: boolean,
  ) { }

  static createFromAny(data: any): Category {
    if (data === null || data === undefined) {
      return null;
    }

    return new Category(
      data.id,
      data.name,
      data.iconUrl,
      data.parentCategoryId,
      data.showOnMainPage,
    );
  }

  getProductImageUrl(): string {
    if (this.iconUrl) {
      return this.iconUrl;
    } else if (this.id != null) {
      return `/store/category_image/${this.id}` + '?type=webshop_product_image';
    }
    return '';
  }

}
